/* Small presentation upgrades; Shopify remains authoritative for commerce. */
const seen = new WeakSet();
export function splitCollectionQuestions(root) {
  if (!root || seen.has(root)) return;
  seen.add(root);
  const faq = root.parentElement.querySelector('[data-r7-collection-faq]');
  if (!faq) return;
  let count = 0;
  for (const paragraph of [...root.querySelectorAll('p')]) {
    const text = paragraph.textContent.trim();
    const match = text.match(/^Q\s*:\s*([\s\S]+?)\s*A\s*:\s*([\s\S]+)$/i);
    if (!match) continue;
    const item = document.createElement('details'), title = document.createElement('summary'), answer = document.createElement('p');
    title.textContent = match[1]; answer.textContent = match[2]; item.append(title, answer); faq.append(item); paragraph.remove(); count++;
  }
  if (count) faq.hidden = false;
}
export function hydratePresence(scope = document) {
  for (const container of scope.querySelectorAll('[data-mag-product-handle]')) {
    const product = window.magCatalogV5?.find(p => p.handle === container.dataset.magProductHandle);
    if (!product) continue;
    for (const metric of container.querySelectorAll('[data-mag-metric]')) {
      const value = Number(product[metric.dataset.magMetric]);
      if (!Number.isInteger(value) || value < 1 || value > 5) continue;
      metric.querySelector('[data-metric-value]').textContent = value + ' / 5';
      const track = metric.querySelector('[data-metric-track]'); track.hidden = false;
      track.setAttribute('role','meter'); track.removeAttribute('aria-hidden'); track.setAttribute('aria-label',metric.querySelector('h3').textContent); metric.querySelector('[data-metric-pointer]').hidden = false;
      track.setAttribute('aria-valuemin','1');track.setAttribute('aria-valuemax','5');track.setAttribute('aria-valuenow',String(value));
      metric.querySelector('[data-metric-pointer]').style.setProperty('--level', ((value - 1) * 25) + '%');
      metric.querySelector('[data-metric-labels]').hidden = false;
    }
    if (typeof product.longevity_text === 'string' && product.longevity_text.trim()) container.querySelector('[data-mag-longevity]').textContent = product.longevity_text;
  }
}
function boot() {
  for (const button of document.querySelectorAll('[data-mag-demo-reel]')) {
    if (seen.has(button)) continue; seen.add(button);
    button.addEventListener('click', () => {
      const dialog=document.createElement('dialog');dialog.className='mag-demo-film';dialog.setAttribute('aria-label',button.dataset.title);
      const close=document.createElement('button');close.type='button';close.textContent='×';close.setAttribute('aria-label','Close demo reel');close.onclick=()=>dialog.close();
      const stage=document.createElement('div');stage.className='mag-demo-film-stage';
      const label=document.createElement('p');label.textContent='DEMO STORYBOARD · NOT A CUSTOMER VIDEO';
      const picture=button.querySelector('img')?.cloneNode(true);if(picture)stage.append(picture);
      const title=document.createElement('h3');title.textContent=button.dataset.title;
      const copy=document.createElement('p');copy.textContent='A place for a genuine first impression, the bottle in hand, and a closer look at the fragrance.';
      const link=document.createElement('a');link.className='mag-text-link';link.href=button.dataset.productUrl;link.textContent='Explore this fragrance';
      stage.append(label,title,copy,link);dialog.append(close,stage);document.body.append(dialog);dialog.addEventListener('close',()=>{dialog.remove();button.focus();},{once:true});dialog.showModal();close.focus();
    });
  }
  for (const link of document.querySelectorAll('a,button')) {
    if (link.querySelector('.mag-thin-arrow')) continue;
    for (const node of [...link.childNodes]) {
      if (node.nodeType !== Node.TEXT_NODE || !node.textContent.includes('↗')) continue;
      const parts = node.textContent.split('↗');
      const fragment = document.createDocumentFragment();
      parts.forEach((part,index) => { if (index) { const arrow = document.createElement('span'); arrow.className = 'mag-thin-arrow'; arrow.setAttribute('aria-hidden','true'); arrow.textContent = '↗'; fragment.append(arrow); } fragment.append(document.createTextNode(part)); });
      node.replaceWith(fragment);
    }
  }
  for (const img of document.querySelectorAll("img[data-mag-image-fallback]")) {
    if (seen.has(img)) continue; seen.add(img);
    const fallback = () => { img.src = img.dataset.magImageFallback; img.removeAttribute("srcset"); img.classList.add("mag-original-photo"); };
    img.addEventListener("error", fallback, {once:true}); if (img.complete && img.naturalWidth === 0) fallback();
  }
  document.querySelectorAll('[data-r7-collection-story]').forEach(splitCollectionQuestions);
  hydratePresence();
  for (const disclosure of document.querySelectorAll('[data-r7-filters]')) {
    if (seen.has(disclosure)) continue; seen.add(disclosure);
    const count = disclosure.querySelectorAll('input:checked,input[type=number][value]:not([value=""])').length;
    const badge = disclosure.querySelector('[data-r7-filter-count]'); if (badge && count) badge.textContent = ` (${count})`;
  }
}
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('mag:catalogue-ready', () => hydratePresence());
}
